import React from "react";
import GallerySliderComp from "./gallerySliderComp";

const ProjectCardView = (props) => {
  return (
    <div className="sm:w-[640px] sm:h-[640px] min-w-[360px] w-[360px] h-[400px] relative rounded-xl overflow-hidden ring-1 ring-primary-200/50 shadow-xl hover:shadow-2xl transition-all duration-300 bg-white transform hover:-translate-y-2 hover:ring-primary-300">
      <div className="w-full sm:h-[400px] h-[200px] group relative p-0 m-0">
        <GallerySliderComp  
          imgSlides={props.imgSlides ? props.imgSlides : []} 
          autoSlide={props.autoSlide} 
          autoSlideInterval={props.autoSlideInterval ? props.autoSlideInterval : 10000}
          showPills={true}
        />
      </div>
      <div className="relative h-[200px] sm:h-[240px] w-full pt-4 bg-gradient-to-br from-primary-50 via-primary-100 to-primary-50 animate-slide-up">
        <div className="w-full px-0">
          <div className="px-8">
            <h2 className="pt-2 font-bold text-[14px] sm:text-lg text-primary-900 animate-fade-in bg-clip-text text-transparent bg-gradient-to-r from-primary-800 to-primary-600">{props.title}</h2>
            <h3 className="font-semibold text-[12px] sm:text-md text-secondary-700 animate-fade-in delay-100">{props.subtitle}</h3>
            <div className="w-full h-[130px] pt-2 overflow-y-auto text-[11px] sm:text-sm text-secondary-600 prose prose-sm animate-fade-in delay-200 scrollbar-thin scrollbar-thumb-primary-200 scrollbar-track-transparent hover:scrollbar-thumb-primary-300">
              <div className="pr-4 text-justify">
                {props.summary()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCardView;
